<template>
  <div class="about-customer">
    <div class="customer-title">合作客户</div>
    <div class="customer-list">
      <div class="customer-list-item" v-for="item in list" :key="item">
        <imgContainer :src="item" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps} from "vue";
import imgContainer from '@/components/imgContainer/index.vue'
let prop = defineProps({
  list: {
    type: Array,
    default: ()=>[],
  }
})
</script>

<style lang="scss" scoped>
.about-customer {
  width: 1200px;
  margin: 70px auto;
}
.customer-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  text-align: center;
  margin-bottom: 30px;
}

.customer-list {
  width: 1200px;
  height: 221px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border: 1px solid #F1F1F1;
}

.customer-list-item {
  border-bottom: 1px solid #F1F1F1;
  border-left: 1px solid #F1F1F1;
  width: 200px;
  height: 80px;
  margin: 12px 19px;
  object-fit: cover;
}

.customer-list-item:nth-child(n+6):nth-child(-n+10) {
  border-bottom: none;
}

.customer-list-item:nth-child(1),
.customer-list-item:nth-child(6) {
  border-left: none;
}
</style>
